import { useQuery } from '@tanstack/react-query';
import type { PolicyLinks } from './types';

const cdnUrl = process.env.CDN_URL ?? '';

export const useGetPolicies = () => {
  return useQuery({
    queryKey: ['cdnDocuments'],
    queryFn: async () => {
      const response = await fetch(`${cdnUrl}/files/app/info.json?lang=en`);

      return response.json() as Promise<PolicyLinks>;
    },
  });
};
